import { SubrouteContext } from 'contexts/SubrouteContext/SubrouteProvider';
import { useContext } from 'react';

export const useSubrouteName = () => useContext(SubrouteContext);
